
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"5.97","y":"1","fill":"#000","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"15.02","y":"1","fill":"#000","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"20.1","height":"5.53","x":"1.95","y":"3.9","fill":"#FAB4CD","fill-rule":"nonzero","rx":"1.32"}}),_c('rect',{attrs:{"width":"20.1","height":"19.1","x":"1.95","y":"3.9","stroke":"#000","rx":"1.96"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M12 21.094a4.83 4.83 0 003.246-1.248c.1-.09.104-.246.009-.34l-.775-.776a.234.234 0 00-.32-.01 3.282 3.282 0 11.081-4.867l-.816.816a.469.469 0 00.332.8h2.618c.259 0 .469-.21.469-.469v-2.618a.469.469 0 00-.8-.332l-.698.698a4.823 4.823 0 00-3.337-1.342 4.853 4.853 0 00-4.853 4.844A4.844 4.844 0 0012 21.094z"}}),_c('path',{attrs:{"stroke":"#000","d":"M1.95 9.43h20.1"}})])])
          )
        }
      }
    